<section class="fullWidthCls scheduleExamDatePg marginAtTop">
  <div class="schExamDetailInfoDetail">
    <div class="container-fluid">
      <div class="row">
        <div class="col s12 m12 l12">
          <div class="schExamDetailInfoDetailLeftSec">
            <img src="./assets/images/dateSelectPgIcon.png" />
          </div>
          <div class="schExamDetailInfoDetailRightSec">
            <h4>{{ selectedExamModel.examCode }}
              <span>{{ selectedExamModel.examName }}</span>
            </h4>
              <p *ngIf="!_utility.usesVirtualLocation(selectedExamModel)"> Address : {{ _utility.getShortStr(selectedExamLocationModel.streetAddress + ', '+ selectedExamLocationModel.city
                +', '+ selectedExamLocationModel.state +', '+ selectedExamLocationModel.country,100) }}
                <a class="locateBtn" href="javascript:void(0);" (click)="locateUs(selectedExamLocationModel.latitude,selectedExamLocationModel.longitude)">
                  <img src="./assets/images/locateUsIcon.png" />
                  <span>Locate Us</span>
                </a>
              </p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col s12 m12 l12">
          <div class="dateToScheduleSec">
            <div class="pickDateToScheduleSecLeft">
              <dp-day-calendar id="scheduleDateCalCls" theme="dp-material" [(ngModel)]="examDateModel.selectedCalDate" (onSelect)="dateSelected($event)"
                [config]="calConfig">
              </dp-day-calendar>
            </div>
            <div *ngIf="examDateModel.showDiv==1" class="pickDateToScheduleSecRight">
              <img src="./assets/images/schExamDateCalIcon.png" />
              <p>Select date to schedule your exam</p>
            </div>
            <div *ngIf="examDateModel.showDiv==2" class="pickedScheduledDateSec">
              <div class="pickedScheduledDateSecRight">
                <div class="pickedScheduledDateCol pickedScheduledDateColHeaderTitle">
                  <div *ngFor="let slotSetDate of examDateModel.timeSlotsByDate">
                    <div class="scheduledMainDate {{ slotSetDate.hasOpenSlots ? 'blueColor':'blackColor'}}">
                      <p>
                        <span>{{ slotSetDate | slotsFormat:'date' }}</span>{{ slotSetDate | slotsFormat:'day' }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="clockNoteRow">
                  <svg class="clock-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36"><title>clock icon</title><path d="M26.44,17.39a.76.76,0,0,0-1,.41.72.72,0,0,0-.06.29.75.75,0,0,0,.22.53.78.78,0,0,0,.24.16.75.75,0,0,0,1-.69.72.72,0,0,0-.06-.29.63.63,0,0,0-.16-.24A.81.81,0,0,0,26.44,17.39Z"></path><path d="M23.48,13a.87.87,0,0,0,.28.05.75.75,0,0,0,.54-.22.74.74,0,0,0,.21-.53.87.87,0,0,0-.05-.28.89.89,0,0,0-.16-.25.79.79,0,0,0-1.07,0,.72.72,0,0,0-.16.25.71.71,0,0,0-.06.28.75.75,0,0,0,.22.53A.85.85,0,0,0,23.48,13Z"></path><path d="M23.23,24.38a.77.77,0,0,0,.54.22.74.74,0,0,0,.52-.22.73.73,0,0,0,0-1.06.67.67,0,0,0-.24-.16.77.77,0,0,0-.82.16.75.75,0,0,0,0,1.06Z"></path><path d="M17.71,25.55a.78.78,0,0,0-.24.16.63.63,0,0,0-.16.24.73.73,0,0,0,0,.58.63.63,0,0,0,.16.24.75.75,0,0,0,1.06,0,.78.78,0,0,0,.16-.24.72.72,0,0,0,.06-.29.75.75,0,0,0-1-.69Z"></path><path d="M12.52,23.16a.77.77,0,0,0-.81.16.73.73,0,0,0,0,1.06.75.75,0,0,0,.53.22.79.79,0,0,0,.53-.22.75.75,0,0,0,0-1.06A.72.72,0,0,0,12.52,23.16Z"></path><path d="M9.32,17.56a.81.81,0,0,0-.17.24.93.93,0,0,0-.05.29.75.75,0,0,0,.22.53.78.78,0,0,0,.24.16.72.72,0,0,0,.29.06.77.77,0,0,0,.53-.22.75.75,0,0,0,.22-.53.72.72,0,0,0-.06-.29.75.75,0,0,0-1.22-.24Z"></path><path d="M12.93,12a.72.72,0,0,0-.16-.25.76.76,0,0,0-.82-.16.67.67,0,0,0-.24.16.74.74,0,0,0-.17.25.71.71,0,0,0-.06.28.72.72,0,0,0,.23.53.7.7,0,0,0,.52.22.93.93,0,0,0,.29-.05,1,1,0,0,0,.25-.17.75.75,0,0,0,.22-.53A.71.71,0,0,0,12.93,12Z"></path><path d="M18,29.77A11.77,11.77,0,0,0,29.75,18a.75.75,0,1,0-1.5,0,10.25,10.25,0,1,1-11-10.22V16A2.18,2.18,0,1,0,19,20l1.77,1.77a.74.74,0,0,0,.53.22.73.73,0,0,0,.53-.22.74.74,0,0,0,0-1.06L20,18.9A2.14,2.14,0,0,0,18.75,16V7A.75.75,0,0,0,18,6.27a11.75,11.75,0,0,0,0,23.5Zm0-12.44a.69.69,0,1,1-.69.69A.69.69,0,0,1,18,17.33Z"></path></svg>
                  Times shown as 24 hour clock
                </div>
                <div class="pickedScheduledDateCol pickedScheduledDateColContentSec">
                  <div *ngFor="let slotSetDate of examDateModel.timeSlotsByDate" class="colBorderCls">
                    <div *ngFor="let slotSetHour of slotSetDate.timeSlotsByHour" class="timeSlot {{slotSetHour.hasOpenSlots ?  'timeSlotDropdown' : ' timeSlotDisabled'}}">
                      <span *ngIf="slotSetHour.display" class="timeSlotTime timeSlotHourGroupExpand" (click)="toggleSlotSet(slotSetHour)">{{ slotSetHour.time }}
                        <span *ngIf="slotSetHour.hasOpenSlots" class="{{slotSetHour.expanded ? 'timeSlotCollapse' : 'timeSlotExpand'}}"></span>
                      </span>
                      <div *ngIf="slotSetHour.expanded" class="timeSlotHourGroup">
                        <div *ngFor="let timeSlot of slotSetHour.timeSlots" class="timeSlot {{timeSlot.isOpen ?  '' : ' timeSlotDisabled'}}">
                          <span *ngIf="timeSlot.display" class="timeSlotTime" (click)="selectTimeSlot(timeSlot)">{{ timeSlot.time }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="clockNoteRow clockNoteRowFooter">
                  <svg class="clock-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36"><title>clock icon</title><path d="M26.44,17.39a.76.76,0,0,0-1,.41.72.72,0,0,0-.06.29.75.75,0,0,0,.22.53.78.78,0,0,0,.24.16.75.75,0,0,0,1-.69.72.72,0,0,0-.06-.29.63.63,0,0,0-.16-.24A.81.81,0,0,0,26.44,17.39Z"></path><path d="M23.48,13a.87.87,0,0,0,.28.05.75.75,0,0,0,.54-.22.74.74,0,0,0,.21-.53.87.87,0,0,0-.05-.28.89.89,0,0,0-.16-.25.79.79,0,0,0-1.07,0,.72.72,0,0,0-.16.25.71.71,0,0,0-.06.28.75.75,0,0,0,.22.53A.85.85,0,0,0,23.48,13Z"></path><path d="M23.23,24.38a.77.77,0,0,0,.54.22.74.74,0,0,0,.52-.22.73.73,0,0,0,0-1.06.67.67,0,0,0-.24-.16.77.77,0,0,0-.82.16.75.75,0,0,0,0,1.06Z"></path><path d="M17.71,25.55a.78.78,0,0,0-.24.16.63.63,0,0,0-.16.24.73.73,0,0,0,0,.58.63.63,0,0,0,.16.24.75.75,0,0,0,1.06,0,.78.78,0,0,0,.16-.24.72.72,0,0,0,.06-.29.75.75,0,0,0-1-.69Z"></path><path d="M12.52,23.16a.77.77,0,0,0-.81.16.73.73,0,0,0,0,1.06.75.75,0,0,0,.53.22.79.79,0,0,0,.53-.22.75.75,0,0,0,0-1.06A.72.72,0,0,0,12.52,23.16Z"></path><path d="M9.32,17.56a.81.81,0,0,0-.17.24.93.93,0,0,0-.05.29.75.75,0,0,0,.22.53.78.78,0,0,0,.24.16.72.72,0,0,0,.29.06.77.77,0,0,0,.53-.22.75.75,0,0,0,.22-.53.72.72,0,0,0-.06-.29.75.75,0,0,0-1.22-.24Z"></path><path d="M12.93,12a.72.72,0,0,0-.16-.25.76.76,0,0,0-.82-.16.67.67,0,0,0-.24.16.74.74,0,0,0-.17.25.71.71,0,0,0-.06.28.72.72,0,0,0,.23.53.7.7,0,0,0,.52.22.93.93,0,0,0,.29-.05,1,1,0,0,0,.25-.17.75.75,0,0,0,.22-.53A.71.71,0,0,0,12.93,12Z"></path><path d="M18,29.77A11.77,11.77,0,0,0,29.75,18a.75.75,0,1,0-1.5,0,10.25,10.25,0,1,1-11-10.22V16A2.18,2.18,0,1,0,19,20l1.77,1.77a.74.74,0,0,0,.53.22.73.73,0,0,0,.53-.22.74.74,0,0,0,0-1.06L20,18.9A2.14,2.14,0,0,0,18.75,16V7A.75.75,0,0,0,18,6.27a11.75,11.75,0,0,0,0,23.5Zm0-12.44a.69.69,0,1,1-.69.69A.69.69,0,0,1,18,17.33Z"></path></svg>
                  Times shown as 24 hour clock
                </div>
              </div>
              <div class="examSeatDetailInfoSec">
                <div class="noExamInfoSec">
                  <span class="blackCircle"></span>No Exam
                </div>
                <div class="seatsAvailableInfoSec">
                  <span class="blueCircle"></span>
                  <span *ngIf="!_utility.usesVirtualLocation(selectedExamModel) else peavailavle">Seats Available</span>
                  <ng-template #peavailavle>Available</ng-template>
                </div>
              </div>
            </div>
            <!-- Schedule Exam div -->
            <div *ngIf="examDateModel.showDiv==3" class="examDateScheduledSecParent">
              <div class="backLinkCls">
                <a (click)="backToTimeList()" href="javascript:void(0);">
                  <i class="material-icons">&#xE5C4;</i>
                  <span>Back</span>
                </a>
              </div>
              <div class="examDateScheduledSec">
                <div class="examDateScheduledLeftSec">
                  <p>
                    <label>Exam Code</label>
                    <span>{{ selectedExamModel.examCode }}</span>
                  </p>
                  <p>
                    <label>Eligibility Code</label>
                    <span>{{ selectedExamModel.eligibilityCode }}</span>
                  </p>
                  <p>
                    <label>Exam Name</label>
                    <span [mdTooltip]="selectedExamModel.examName">{{ _utility.getShortStr(selectedExamModel.examName, 35) }}</span>
                  </p>
                </div>
                <div class="examDateScheduledRightSec">
                  <p>
                    <label>Time</label>
                    <span>{{ examDateModel.selectedTimeSlot.time }}</span>
                    <em class="clockNote">(time shown as 24 hour clock)</em>
                  </p>
                  <p *ngIf="_utility.usesVirtualLocation(selectedExamModel)">
                    <label>TimeZone</label>
                    <span>{{ selectedExamModel.virtualLocationTimeZone.name }}</span>
                  </p>
                  <p *ngIf="_utility.usesVirtualLocation(selectedExamModel)">
                    <label>Country</label>
                    <span>{{ selectedExamModel.virtualLocationCountry.name }}</span>
                  </p>
                  <p>
                    <label>Date</label>
                    <span>{{ examDateModel.selectedTimeSlot.date }}</span>
                  </p>
                </div>
              </div>
              <div class="examScheduleUpdateTitleSec">
                <p class="updateCardSecTitle">
                  <span>Update Personal Information</span>
                </p>
                <md-card>
                  <md-card-content>
                    <form class="example-form" [formGroup]="scheduleForm" novalidate>
                      <div class="col s12 m6 l6 ">
                        <div class="errorZoneSec">
                          <md-form-field class="example-full-width">
                            <input mdInput placeholder="Phone Number" formControlName="phoneNumber" maxlength="20">
                          </md-form-field>
                          <p requiredField *ngIf="scheduleForm.controls.phoneNumber.errors && scheduleForm.controls.phoneNumber.errors.required"></p>
                          <p validatePhoneNumber *ngIf="scheduleForm.controls.phoneNumber.errors && scheduleForm.controls.phoneNumber.errors.pattern"></p>
                        </div>
                      </div>
                      <div class="col s12 m6 l6 ">
                        <div class="errorZoneSec">
                          <md-form-field class="example-full-width">
                            <input type="text" mdInput placeholder="Certification ID" maxlength="30" formControlName="certificateId" (keyup)="onCertIDFieldKeyup()">
                          </md-form-field>
                          <p validateCertificateId *ngIf="scheduleForm.controls.certificateId.errors && scheduleForm.controls.certificateId.errors.pattern"></p>
                        </div>
                      </div>
                    </form>
                  </md-card-content>
                </md-card>
              </div>
              <div class="termConditionSec">
                <md-checkbox name="scTnC" [(ngModel)]="examDateModel.tncChecked">I Agree.</md-checkbox>
                <a href="https://www.redhat.com/en/about/red-hat-training-policies" target="_blank">Terms and Conditions</a>
              </div>
              <button [disabled]="scheduleForm.invalid==true || examDateModel.tncChecked==false || examDateModel.submitInProcess==true"
                (click)="reserveExam()" class="locateBtn" href="javascript:void(0);" title="Schedule Exam">
                <i class="material-icons">&#xE55F;</i>
                <span>Reserve</span>
              </button>
            </div>
            <!-- Reschedule Exam div -->
            <div *ngIf="examDateModel.showDiv==4" class="examDateReScheduledSecParent">
              <div class="backLinkCls">
                <a (click)="backToTimeList()" href="javascript:void(0);">
                  <i class="material-icons">&#xE5C4;</i>
                  <span>Back</span>
                </a>
              </div>
              <div class="examDateReScheduledSec">
                <div class="leftRescheduleS" *ngIf="!_utility.usesVirtualLocation(selectedExamModel)">
                  <p class="reschdlScreenHeading">Location Details</p>
                  <div class="examDateReScheduledLeftSec">
                    <p>
                      <label>Location Name</label>
                      <span>{{ selectedExamLocationModel.code }}</span>
                    </p>
                    <p>
                      <label>Location Address</label>
                      <span mdTooltip="{{ selectedExamLocationModel.streetAddress }}">
                        {{ _utility.getShortStr(selectedExamLocationModel.streetAddress,35) }}
                      </span>
                    </p>
                    <p>
                      <label>City</label>
                      <span>{{ selectedExamLocationModel.city }}</span>
                    </p>
                    <p>
                      <label>State</label>
                      <span>{{ selectedExamLocationModel.state }}</span>
                    </p>
                    <p>
                      <label>Zip</label>
                      <span>{{ selectedExamLocationModel.zipCode }}</span>
                    </p>
                    <p>
                      <label>Operation Hours</label>
                      <span>{{ _utility.getOperationalHours(selectedExamLocationModel.locationTimeDetails, examDateModel.selectedTimeSlot.date) }}
                      </span>
                    </p>
                    <p>
                      <label>Keyboard Type</label>
                      <span>{{ selectedExamLocationModel.keyboardType }}</span>
                    </p>
                  </div>
                </div>
                <div class="RightRescheduleS">
                  <p class="reschdlScreenHeading">Selected Exam</p>
                  <div class="examDateReScheduledRightSec">
                    <p>
                      <label>Exam Name</label>
                      <span [mdTooltip]="selectedExamModel.examName">{{ _utility.getShortStr(selectedExamModel.examName,35) }}</span>
                    </p>
                    <p>
                      <label>Previous Date</label>
                      <span>{{ selectedExamModel.examStartDateTime | dateTimeFormat:_appConfig.dateFormat }}</span>
                    </p>
                    <p>
                      <label>Previous Time</label>
                      <span> {{ selectedExamModel.examStartDateTime | dateTimeFormat:_appConfig.timeFormatExamCards }}</span>
                      <em class="clockNote">(time shown as 24 hour clock)</em>
                    </p>
                    <p *ngIf="!_utility.usesVirtualLocation(selectedExamModel)">
                      <label>Previous Location</label>
                      <span> {{ selectedExamModel.locationName }}</span>
                    </p>
                    <p *ngIf="_utility.usesVirtualLocation(selectedExamModel)">
                      <label>Previous TimeZone</label>
                      <span> {{ selectedExamModel.timeZone }}</span>
                    </p>
                    <p *ngIf="_utility.usesVirtualLocation(selectedExamModel)">
                      <label>Previous Country</label>
                      <span> {{ selectedExamModel.locationCountryName }}</span>
                    </p>
                    <p>
                      <label>New Date</label>
                      <span>{{ examDateModel.selectedTimeSlot.date }}</span>
                    </p>
                    <p>
                      <label>New Time</label>
                      <span>{{ examDateModel.selectedTimeSlot.time }}</span>
                      <em class="clockNote">(time shown as 24 hour clock)</em>
                    </p>
                    <p *ngIf="_utility.usesVirtualLocation(selectedExamModel)">
                      <label>New TimeZone</label>
                      <span>{{ selectedExamModel.virtualLocationTimeZone.name }}</span>
                    </p>
                    <p *ngIf="_utility.usesVirtualLocation(selectedExamModel)">
                      <label>New Country</label>
                      <span>{{ selectedExamModel.virtualLocationCountry.name }}</span>
                    </p>
                    <p *ngIf="!_utility.usesVirtualLocation(selectedExamModel)">
                      <label>New Location</label>
                      <span> {{ selectedExamLocationModel.code }}</span>
                    </p>
                  </div>
                </div>
              </div>
              <div class="examScheduleUpdateTitleSec">
                <p class="updateCardSecTitle">
                  <span>Update Personal Information</span>
                </p>
                <md-card>
                  <md-card-content>
                    <form class="example-form" [formGroup]="scheduleForm" novalidate>
                      <div class="col s12 m6 l6 ">
                        <div class="errorZoneSec">
                          <md-form-field class="example-full-width">
                            <input mdInput placeholder="Phone Number" formControlName="phoneNumber" maxlength="20">
                          </md-form-field>
                          <p requiredField *ngIf="scheduleForm.controls.phoneNumber.errors && scheduleForm.controls.phoneNumber.errors.required"></p>
                          <p validatePhoneNumber *ngIf="scheduleForm.controls.phoneNumber.errors && scheduleForm.controls.phoneNumber.errors.pattern"></p>
                        </div>
                      </div>
                      <div class="col s12 m6 l6 ">
                        <div class="errorZoneSec">
                          <md-form-field class="example-full-width">
                            <input mdInput placeholder="Certification ID" maxlength="30" formControlName="certificateId" (keyup)="onCertIDFieldKeyup()">
                          </md-form-field>
                          <p validateCertificateId *ngIf="scheduleForm.controls.certificateId.touched && scheduleForm.controls.certificateId.errors && scheduleForm.controls.certificateId.errors.pattern"></p>
                        </div>
                      </div>
                    </form>
                  </md-card-content>
                </md-card>
              </div>
              <div class="termConditionSec">
                <md-checkbox [(ngModel)]="examDateModel.tncChecked">I Agree.</md-checkbox>
                <a href="https://www.redhat.com/en/about/red-hat-training-policies" target="_blank">Terms and Conditions</a>
              </div>
              <button [disabled]="scheduleForm.invalid || examDateModel.tncChecked==false || examDateModel.submitInProcess" (click)="reserveExam()"
                class="locateBtn" title="Reschedule Exam">
                <img src="./assets/images/reservedDateIcon.png">
                <span>Reschedule</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/schedule-exam-date/schedule-exam-date.component.html